import { COUNTRY, IS_REQUIRED} from '../../../../../common/constants';
import { stringToBoolean } from '../../../../../common/FunctionsUtils';
import { QUALITE_ACTIONNNAIRE } from '../../../../../utils/constantes/US/KYCFORM';
import { isBicValid, isIdentifiantFacturation, isTvaIntraValid } from '../../../../../common/Validators';

const kycValidators = (values) => {
  const errors = {};

  if (values.soumisTVA) {
    if (!values.codeTVAIntracommunautaire) {
      errors.codeTVAIntracommunautaire = IS_REQUIRED;
    }
    const tvaError = isTvaIntraValid(values.codeTVAIntracommunautaire);
    if (tvaError !== undefined) {
      errors.codeTVAIntracommunautaire = tvaError;
    }

    if (values.aIdentifiantFacturationElectronique) {
      const identifiantFacturationElectroniqueError = isIdentifiantFacturation(values.identifiantFacturationElectronique);
      if (!values.identifiantFacturationElectronique) {
        errors.identifiantFacturationElectronique = IS_REQUIRED;
      } else if (identifiantFacturationElectroniqueError !== undefined) {
        errors.identifiantFacturationElectronique = identifiantFacturationElectroniqueError;
      }
    }
  }

  const bicError = isBicValid(values.codeBIC);
  if (stringToBoolean(values.isBanque)) {
    if (!values.codeBIC) {
      errors.codeBIC = IS_REQUIRED;
    } else if (bicError !== undefined) {
      errors.codeBIC = bicError;
    }
  }

  if (stringToBoolean(values.regulateur)) {
    if (!values.nomRegulateur) {
      errors.nomRegulateur = IS_REQUIRED;
    }
    if (!values.referenceAgrement) {
      errors.referenceAgrement = IS_REQUIRED;
    }
  }

  if (stringToBoolean(values.isEntrepriseCotee)) {
    if (!values.entrepriseCotee) {
      errors.entrepriseCotee = IS_REQUIRED;
    }
  }

  if (
    stringToBoolean(values.needPaysPersonneMorale) &&
    values.paysPersonneMorale &&
    values.paysPersonneMorale === JSON.stringify(COUNTRY.FRANCE)
  ) {
    errors.paysPersonneMorale = "Vous devez indiquer le pays de la personne morale dont l'adresse n'est pas en France";
  }

  if (!values.pays) {
    errors.pays = IS_REQUIRED;
  }

  if (!values.principauxMarches) {
    errors.principauxMarches = IS_REQUIRED;
  }

  if (!values.principauxPays) {
    errors.principauxPays = IS_REQUIRED;
  }

  if (!values.actionnaires || !values.actionnaires.length) {
    errors.nbActionnaires = 'Vous devez renseigner au moins un actionnaire';
  }
  if (values.actionnaires) {
    const actionnairesArrayErrors = [];
    let total = 0;
    values.actionnaires.forEach((actionnaire, index) => {
      if (!actionnaire.nom) {
        actionnairesArrayErrors[index] = { ...actionnairesArrayErrors[index], nom: IS_REQUIRED };
      }
      if (!actionnaire.prenom && actionnaire.beneficiaireIsPersonneMorale === 'non') {
        actionnairesArrayErrors[index] = { ...actionnairesArrayErrors[index], prenom: IS_REQUIRED };
      }
      if (!actionnaire.adressePermanenteRue) {
        actionnairesArrayErrors[index] = { ...actionnairesArrayErrors[index], adressePermanenteRue: IS_REQUIRED };
      }
      if (!actionnaire.adressePermanenteCode) {
        actionnairesArrayErrors[index] = { ...actionnairesArrayErrors[index], adressePermanenteCode: IS_REQUIRED };
      }
      if (!actionnaire.adressePermanenteVille) {
        actionnairesArrayErrors[index] = { ...actionnairesArrayErrors[index], adressePermanenteVille: IS_REQUIRED };
      }
      if (!actionnaire.isSameAddress) {
        if (!actionnaire.adressePostaleRue) {
          actionnairesArrayErrors[index] = { ...actionnairesArrayErrors[index], adressePostaleRue: IS_REQUIRED };
        }
        if (!actionnaire.adressePostaleCode) {
          actionnairesArrayErrors[index] = { ...actionnairesArrayErrors[index], adressePostaleCode: IS_REQUIRED };
        }
        if (!actionnaire.adressePostaleVille) {
          actionnairesArrayErrors[index] = { ...actionnairesArrayErrors[index], adressePostaleVille: IS_REQUIRED };
        }
      }
      if (!actionnaire.paysFiscal) {
        actionnairesArrayErrors[index] = { ...actionnairesArrayErrors[index], paysFiscal: IS_REQUIRED };
      }
      if (!actionnaire.parts) {
        actionnairesArrayErrors[index] = { ...actionnairesArrayErrors[index], parts: IS_REQUIRED };
      }
      if (actionnaire.parts) {
        if (isNaN(actionnaire.parts)) {
          actionnairesArrayErrors[index] = { ...actionnairesArrayErrors[index], parts: 'Seul les nombres sont acceptés' };
        } else if (+actionnaire.parts > 100) {
          actionnairesArrayErrors[index] = {
            ...actionnairesArrayErrors[index],
            parts: 'Les pourcentages doivent être inférieur ou égal à 100'
          };
        }
      }
      if (actionnaire.qualite === QUALITE_ACTIONNNAIRE.DIRIGEANT && !actionnaire.fonctionDirigeant) {
        actionnairesArrayErrors[index] = { ...actionnairesArrayErrors[index], fonctionDirigeant: IS_REQUIRED };
      }
      if (
        (actionnaire.qualite === QUALITE_ACTIONNNAIRE.BENEFICIAIRE || actionnaire.qualite === QUALITE_ACTIONNNAIRE.PROCURATION) &&
        !actionnaire.activiteBeneficiaire
      ) {
        actionnairesArrayErrors[index] = { ...actionnairesArrayErrors[index], activiteBeneficiaire: IS_REQUIRED };
      }
      total += Number(actionnaire.parts) || 0;
    });
    if (actionnairesArrayErrors.length) {
      errors.actionnaires = actionnairesArrayErrors;
    }
    if (total > 100) {
      errors.parts = 'Les pourcentages doivent être inférieur ou égal à 100';
    }
  }
  return errors;
};

export default kycValidators;
